module.exports = __webpack_public_path__ + "img/managed.16b57e2.svg";